function filterMemberContent(data) {
  data.dynamicAcf.dynamicContent = data.dynamicAcf.dynamicContent.filter((block) => !block.membersOnly)
  data.previous = null
  data.next = null

  return data
}

export default filterMemberContent
